import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-registration-landing',
  templateUrl: './identity-mgt-registration-landing.component.html',
  styleUrls: ['./identity-mgt-registration-landing.component.scss']
})
export class IdentityMgtRegistrationLandingComponent implements OnInit {
  categories: {};
  selection = { name: '' };
  constructor(private router: Router,
    public forgotService: ForgotService, 
    private appInsightsService: AppInsightsService) {
    this.categories = [
      { cat_id: 1, name: 'I forgot my user ID' },
      { cat_id: 2, name: 'I forgot my password' }
    ];
  }
  ngOnInit() {
    window.scrollTo(0, 0);
    this.appInsightsService.logEvent("Forgot UI Page - Registration Landing");
  }

  next() {
    if (this.selection) {
      if (this.selection.name === 'I forgot my password') {
        this.forgotService.setType('pwd');
        this.router.navigate(['/c']);
      }
      if (this.selection.name === 'I forgot my user ID') {
        this.forgotService.setType('userid');
        this.router.navigate(['/c']);
      }
    } else {
      return;
    }
  }
}
